// noinspection JSNonASCIINames,NonAsciiCharacters

export const invoiceTranslations = {
    invoice_list: {
        inv_from: "Инвойсы с",
        inv_to: "Инвойсы по",
        invalid_date_range: "Неправильный период",
        max_allowed_period: "Макс. возможный период - 365 дней",
        period: {
            this_month: "Тек. месяц",
            prev_month: "Пред. месяц",
            this_year: "Тек. год",
            prev_year: "Пред. год",
        },
        columns: {
            invoice_no: "Ном. счета",
            date: "Дата",
            due: "Срок оплаты",
            customer: "Клиент",
            vendor: "Поставщик",
            total: "Всего",
            paid: "Оплачено",
        },
        lock_reason: {
            has_payments: "Инвойсы, по которым были платежи - нельзя удалить.<br/>Пожалуйста свяжитесь с вашим бухгалтером, если вы хотите его удалить",
            too_old: "Старые инвойсы - нельзя удалить.<br/>Пожалуйста свяжитесь с вашим бухгалтером, если вы хотите его удалить",
            created_ext: "Инвойсы, созданные во внешней системе - нельзя удалить.<br/>Пожалуйста свяжитесь с вашим бухгалтером, если вы хотите его удалить",
        }
    },
    single_invoice: {
        inv_number: "Счет #",
        date: "Дата",
        due: "Срок оплаты",
        party: {
            "Invoice from": "Счет от",
            "Invoice to": "Счет для",
        },
        conversion_alert: "Инвойс был создан во внешней системе.<br/>Генерация PDF переведет его во внутренний формат",
        download_invoice: "Скачать инвойс",
        duplicate_invoice: "Скопировать инвойс",
        send_via_email: "Отправить по эл. почте",
        email_sent_successfully: "Электронное письмо было успешно отправлено!",
        table: {
            description: "Описание",
            quantity: "Количество",
            unit: "Ед.изм.",
            price: "Цена",
            disc_pct: "Скидка %",
            total_no_vat: "Всего, без НДС",
            vat_total: "Всего НДС",
            vat: "НДС",
            total: "Всего",
        },
        amount_to_pay: "Всего к оплате",
    },
    send_invoice_via_email: {
        title: "Отправить счет",
        to: "Получатель счета (адрес эл. почты)",
        subject: "Заголовок письма",
        body: "Основной текст письма",
        file_name: "Имя прикрепленного файла",
        copy_to: "Отправить копию (Список адресов, разделенных запятой)",
        email_header: "Счет {{invoiceNo}} от {{companyName}}",
        email_body: "Здравствуйте,\n\nСчет находится во вложении к письму.\n\nС уважением,\n{{companyName}}"
    },
    invoice_wizard: {
        customer_step: {
            header: "Клиент",
            subtitle: "Пожалуйста, выберите клиента, которому вы выставляете счет или создайте нового",
            new_customer: "Создать",
            select_customer: "Выберите клиента",
            add_new_customer_question: "Вы хотите создать нового клиента?",
            clear_data: "Удаляет все ранее введенные данные, включая строки инвоса",
        },
        invoice_content_step: {
            header: "Содержание счета",
            invoice_to: "Счет для",
            inv_number: "Номер счета",
            inv_number_was_used: "Уже был использован",
            date: "Дата",
            due: "Срок оплаты",
            currency: "Валюта",
            lines: {
                item_service: "Позиция/Услуга",
                description: "Описание",
                description_too_long: "Слишком длинное описание",
                quantity: "Количество",
                unit: "Ед.изм.",
                price: "Цена",
                disc_pct: "Скидка %",
                total_no_vat: "Всего, без НДС",
                vat: "НДС",
                actions: "Действия",
            },
            comment: "Комментарий",
            comment_too_long: "Слишком длинный комментарий",
            comment_placeholder: "Пожалуйста, оставьте комментарий, относящийся к инвойсу",
            new_line: "Новая строка",
            skip_preview: "Пропустить шаг и создать ивнойс",
            tax_rate_warning: "Вы выбрали ставку VAT 22%, хотя дата инвойса после 1 Июля 2025 года.<br/>С 01.07.2025 года в Эстонии ставка VAT равна 24%.<br/>Если у вас есть вопрос в связи с этим, обратитесь в поддержку."
        },
        new_invoice_header: "Новый инвойс",
        create_invoice: "Создать инвойс"
    },
}